import numberDisplay from "../../../../../components/numberDisplay/numberDisplay";
import { connect } from "react-redux";

export default connect((state) => ({
  value: state.funnelChart.funnelChartData.funnel_laser.averageNumberOfDaysToConversion.value,
  disableAnimation: state.funnelChart.currentUser.qa
}))(numberDisplay);
